import React, { Component } from 'react'
import OtpInputs from './OtpInputs/OtpInputs';
import './CustomerDeclaration.css'
import DeclarationText from './DeclarationText';
import { Group, resend } from '../../images/images';
import { getApiData } from '../../api/api';
import { compose } from "redux";
import { connect } from "react-redux";
import { showLoader } from "../../redux/actions/action_loader";
import Error from "../Error/Error";
import ThankYouPage from './ThankYouPage/ThankYouPage';
import OtpScreen from './OtpScreen';
import AxiosRequest from "../../utils/axios";
import { getConfigFromParamStore, getConfigFromStroage } from '../../utils/getUrlsFromAws';
import { Button } from 'unified-ui-components-library';
const axios = new AxiosRequest().getClient()

class CustomerDeclaration22 extends Component {
    sendOtpTimeInterval

    constructor(props) {
        super(props);
        this.state = {

            showExpireTime: false,
            posvRefNumber: "",
            planName: "",
            policyTerm: "",
            policyNumber: "87193448",
            premiumPaymentTerm: "",
            annualPremium: "1200",
            linkValid: "",
            businessMsg: "",
            customerName: 'Abhishek',
            customerEmail: '',
            customerMobNum: '',
            customerAccNum: '',
            isRenewalViaDirectDebit: 'y',
            disableSubmitButton: true,
            checkboxValue: "",
            sendOtpAttempt: 1,
            sendOtpTime: 60,
            showSendOtpTime: false,
            sendOtpButtonText: "Send Otp",
            disableOtpButton: false,
            showThankYouPage: false,
            msgDescription: '',
            successMsg: '',
            errMsg: '',
            hideOtpBox: true,
            loading: false,
            moreText: false
        }
    }

    componentDidMount() {
        console.log('digit2');
        const event = new CustomEvent("yesBank", { detail: { logo: 'Yes_Bank' } });
        document.dispatchEvent(event);
        document.addEventListener("keyup", this.inputValueCheck);
        this.startLoad();

    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.inputValueCheck);
    }


    handleCheckbox = (value) => {
        this.setState({ checkboxValue: value });
    };

    handleMoreText = (bool) => {
        this.setState({ moreText: bool })
    }
    getFormattedTime = (sec) => {
        let min = Math.floor(sec / 60)
        let second = sec % 60
        return `0${min}:${second < 10 ? '0' + second : second}`
    }


    startLoad = async () => {
        this.props.showLoader(true);
        let urlsData = getConfigFromStroage();
        if (!urlsData) {
            const resp = await getConfigFromParamStore()
        }
        let [param, payload] = window.location.search.split('=')
        console.log("param", param);
        const { url, body } = getApiData('customerDeclarationValidlink')
        body.request.payload.posvRefNumber = payload
        let response;
        try {
            this.props.showLoader(true);
            response = await axios.post(url, body)
            const {
                customerName,
                posvRefNumber,
                planName,
                policyTerm,
                policyNumber,
                premiumPaymentTerm,
                annualPremium,
                linkValid,
                businessMsg,
                isRenewalViaDirectDebit,
                customerEmail,
                customerMobNum,
                fromAccountId
            } = response.data.response.payload;
            this.setState({
                customerName: customerName ? customerName : "Customer",
                customerEmail,
                customerMobNum,
                customerAccNum: fromAccountId,
                posvRefNumber,
                planName: planName ? planName.replace(/[0-9]/g, '') : '',
                policyTerm,
                policyNumber,
                premiumPaymentTerm,
                annualPremium: annualPremium ? annualPremium : '-',
                linkValid: linkValid ? linkValid : 'n',
                businessMsg,
                isRenewalViaDirectDebit: isRenewalViaDirectDebit ? isRenewalViaDirectDebit.toLowerCase() : 'y'

            })

        } catch (error) {
            console.log("Error", error);
            this.setState({ linkValid: "N", businessMsg: 'Invalid' });

        }
        finally {
            this.props.showLoader(false);
        }
    }


    sendOtp = async () => {
        clearInterval(this.expireOtpTimeInterval)
        clearInterval(this.sendOtpTimeInterval);
        this.props.showLoader(true)
        this.setState({
            showSendOtpTime: true, sendOtpTime: 60, sendOtpButtonText: "Resend Otp", sendOtpAttempt: this.state.sendOtpAttempt + 1, successMsg: '', errMsg: '', loading: true
        })

        this.sendOtpTimeInterval = setInterval(() => {
            this.setState({ sendOtpTime: this.state.sendOtpTime - 1 }, () => {
                if (this.state.sendOtpTime == 0 || this.state.sendOtpAttempt == 2) {
                    clearInterval(this.sendOtpTimeInterval);
                    this.setState({ showSendOtpTime: false })
                }
            })
        }, 1000);
        if (this.state.sendOtpAttempt >= 3) {
            this.setState({ disableOtpButton: true })
        }
        const { url, body } = getApiData('customerDeclarationGenOtp')
        body.request.payload.posvRefNumber = this.state.posvRefNumber
        try {
            let response = await axios.post(url, body)
            if (response.data.response.msgInfo.msgCode == 200) {
                this.setState({ successMsg: response.data.response.payload.businessMsg, errMsg: '', })

                //    
            }
            else {
                this.setState({ errMsg: response.data.response.payload.businessMsg, successMsg: '' })
            }
        }
        catch (error) {
            console.log('send otp err', error);
            this.setState({ errMsg: '', successMsg: '' })
        }
        finally {
            this.props.showLoader(false)
            this.setState({ hideOtpBox: false, loading: false })
        }

    }


    inputValueCheck = () => {
        if (document.querySelectorAll(".cd_input_otp").length == 0) {
            return
        }
        const [i0, i1, i2, i3, i4, i5] = document.querySelectorAll(".cd_input_otp");
        if (i0.value && i1.value && i2.value && i3.value && i4.value && i5.value) {
            this.setState({ disableSubmitButton: false });
        } else {
            this.setState({ disableSubmitButton: true });
        }
    };


    submitOtp = async () => {
        this.props.showLoader(true)
        this.setState({ disableSubmitButton: true })
        const inps = document.getElementsByClassName("cd_input_otp");
        let otp = "";
        for (let inp of inps) {
            otp += inp.value;
        }

        const { url, body } = getApiData('customerDeclarationValidOtp')
        body.request.payload.posvRefNumber = this.state.posvRefNumber
        body.request.payload.otp = otp
        try {
            let response = await axios.post(url, body)
            const { msgCode } = response.data.response.msgInfo;
            if (msgCode == 200) {
                this.setState({ showThankYouPage: true, showSendOtpTime: false, disableOtpButton: true, errMsg: '', successMsg: '' })
                clearInterval(this.sendOtpTimeInterval);
            }
            else {
                this.setState({ errMsg: response.data.response.payload.businessMsg, successMsg: '' })
            }
        }
        catch (error) {
            console.log('submit otp err', error);
            this.setState({ errMsg: 'Some Error occured', successMsg: '', })
        }
        finally {
            this.props.showLoader(false)
            this.setState({ disableSubmitButton: false, })
        }
    }

    getDetailsHtml = () => {
        const {
            policyTerm,
            policyNumber,
            premiumPaymentTerm,
            annualPremium,
        } = this.state
        return (
            <div className="cd-user-details-main">
                <div className='cd-user-details-container '>
                    <p className='cd-user-detail'>Policy Number </p>
                    <p className='cd-user-value'>{policyNumber}</p>
                </div>
                <div className='cd-user-details-container '>
                    <p className='cd-user-detail'>Premium Payment Term </p>
                    <p className='cd-user-value'>{premiumPaymentTerm}yrs</p>
                </div>
                <div className='cd-user-details-container '>
                    <p className='cd-user-detail'>Policy Term </p>
                    <p className='cd-user-value'>{policyTerm}yrs</p>
                </div>
                {/* <div className='cd-user-details-container '>
                <p className='cd-user-detail'>Sum Assured </p>
                <p className='cd-user-value'>₹ 10 Lakh</p>
            </div> */}
                <div className='cd-user-details-container '>
                    <p className='cd-user-detail'>Premium </p>
                    <p className='cd-user-value'>₹ {annualPremium}</p>
                </div>
                {/* <div className='cd-user-details-container '>
                <p className='cd-user-detail'>Life Covered (Sum Assured) </p>
                <p className='cd-user-value'>₹ 2 Cr</p>
            </div>
            <div className='cd-user-details-container '>
                <p className='cd-user-detail'>Premium Issue Date</p>
                <p className='cd-user-value'>25/03/2011</p>
            </div> */}
            </div>
        )
    }

    render() {
        const { customerName, isRenewalViaDirectDebit,
            planName,
            policyTerm,
            policyNumber,
            premiumPaymentTerm,
            annualPremium,
            linkValid,
            businessMsg,
            disableSubmitButton,
            checkboxValue,
            showSendOtpTime,
            sendOtpTime,
            disableOtpButton,
            showExpireTime,
            showThankYouPage,
            successMsg,
            errMsg,
            customerEmail,
            customerMobNum,
            customerAccNum,
            hideOtpBox,
            moreText,
            loading
        } = this.state;

        const otpScreenProps = {
            planName,
            customerMobNum,
            errMsg,
            annualPremium,
            checkboxValue,
            sendOtp: this.sendOtp,
            submitOtp: this.submitOtp,
            sendOtpTime,
            disableOtpButton,
            disableSubmitButton,
            getFormattedTime: this.getFormattedTime,
            showSendOtpTime
        }

        const thankYouPageProps = {
            customerMobNum,
            customerEmail,
            isRenewalViaDirectDebit
        }
        const declarationProps = {
            policyNumber,
            moreText,
            handleMoreText: this.handleMoreText,
            isRenewalViaDirectDebit
        }

        return (
            <>
                {showThankYouPage ? <div className='thankyou-modal'>
                    <ThankYouPage thankYouPageProps={thankYouPageProps} />

                </div> :
                    <>{
                        linkValid.toLocaleLowerCase() === "y" ?
                            <>
                                <div className="cd-main">
                                    {/* <div className={`cd-modal  ${showThankYouPage ? 'cd-show' :'cd-hide'}`} onClick={()=>this.setState({showThankYouPage:!showThankYouPage})}>
                                <ReadMoreScreen/>
                                </div> */}
                                    <div className={`cd-mainContainer ${!moreText ? "cd-bottom-0" : ""}`}>
                                        <div className='cd-mainContainer-1 '>
                                            <div className="cd-sub-cntnr-1">

                                                <div className="cd-head-text-cntnr">
                                                    <p className="cd-name-text">
                                                        Dear {customerName},
                                                    </p>
                                                    <p className="cd-plan-name-text">
                                                        Please complete the payment for your {planName}
                                                    </p>
                                                </div>

                                                <p className='cd-policy-details-text'>Policy Details:</p>
                                                {this.getDetailsHtml()}
                                                <div className='cd-big-img-container'>
                                                    <img src={Group} alt="" width='284px' height='214px' />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='cd-mainContainer-2'>
                                            <div className="cd-sub-cntnr-2">
                                                {
                                                    hideOtpBox ?
                                                        <>
                                                            <div className="cd-responsive">
                                                                <div className="cd-head-text-cntnr">
                                                                    <p className="cd-name-text">
                                                                        Dear {customerName},
                                                                    </p>
                                                                    <p className="cd-plan-name-text">
                                                                        Please complete the payment for your {planName}
                                                                    </p>
                                                                </div>
                                                                {
                                                                    this.getDetailsHtml()
                                                                }

                                                            </div>
                                                            <div className="cd-main-text-cntnr">
                                                                <p className="cd-main-text-1">
                                                                    Please authorize to setup Auto-debit with renewal for future payments on your Yes Bank Account <span className='accNum-secret'> XXXX XXXX </span> <span className='accNum'>{customerAccNum}</span>
                                                                </p>

                                                            </div>

                                                            <div className="scroll">
                                                                <div className="sub-scroll">
                                                                    <div className="cd-declaration-main-cntnr">

                                                                        <>
                                                                            <div className='cd-declaration-check'>
                                                                                {/* <input type="checkbox" name="confirmCheck" id="confirmCheck" /> */}
                                                                                <label className="cd-confirm-checkobox">
                                                                                    <input type="checkbox"
                                                                                        // disabled={this.state.submitting}
                                                                                        value={this.state.checkboxValue}
                                                                                        onChange={(event) => this.handleCheckbox(event.target.checked)}
                                                                                    />
                                                                                    <span className="cd-checkmark"></span>
                                                                                </label>
                                                                                <div className='cd-confirm-text-container'>
                                                                                    <DeclarationText declarationProps={declarationProps} />
                                                                                </div>
                                                                            </div>
                                                                        </>



                                                                    </div>

                                                                    <div className="cd-btn-cntnr">


                                                                        <div className="button_div_unified cd_pay_btn">
                                                                            <Button
                                                                                // className='cd-pay-btn'
                                                                                onClick={this.sendOtp}
                                                                                disabled={!checkboxValue || loading}
                                                                                buttonType='primary'
                                                                                size='large'
                                                                            >Setup Auto-debit</Button>
                                                                        </div>


                                                                    </div>


                                                                    <div className="cd-mobNum-cntnr">
                                                                        <p className="cd-mobNum-text">
                                                                            We’ll send an OTP to your registered mobile number XXXXXX{customerMobNum}
                                                                        </p>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </>
                                                        :
                                                        <OtpScreen otpScreenProps={otpScreenProps} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </> : <>
                                <Error errorMsg={businessMsg} />
                            </>
                    }</>
                }


            </>
        )
    }
}

export default compose(
    connect(null, { showLoader })
)(CustomerDeclaration22);

